import React from "react";
import Search from "../components/search/Search";

const SearchPage = () => {
  return (
    <div>
      <Search />
    </div>
  );
};

export default SearchPage;
